import request from "./request";

// 登录
const goLogin = (front,siteId,username, password) => {
  return request.post('/login', {
    front:front,
    siteId:siteId,
    username: username,
    password: password
  })
}


//获取当前用户权限
const getUserMenu = (token) => {
    return request.post({
        url: '/api/site/user/getCurrentUserInfo',
        data: {'token': token}
    })
}

//退出登陆
const logout = (token) => {
    return request.get({
        url: '/logout',
        // data: {'token': token}
    })
}


// 首页
const getHome = (siteId,id) => {
  return request.post('/api/site/user/getUserInfo',{"siteId":siteId,"token":id})
}

// 首页 切换学期
const getTerm = (siteUserId,siteId,termId) => {
    return request.post('/api/site/user/getTermInfo',{"siteUserId":siteUserId,"siteId":siteId,'termId':termId})
}

// 课程中心
const studyIndex = (siteId,id) => {
  return request.post('/api/class/getCourseInfo',{"siteId":siteId,"token":id})
}

// 修改密码
const updatepass = (uid,old_password, password, password2) => {
  return request.post('/api/site/user/updatepass', {
      "uid":uid,
    "oldPassword":old_password,
    "password": password,
    "password2":password2
  })
}



// 练习  课程考试
const courseExercises = (siteId,id,type, c_id) => {
  return request.post('/api/exam/getCourseExis', {
      "siteId":siteId,
    "token":id,
    "types":type,
    "cid":c_id
  })
}
// 做题记录
const makeNotes = (siteId,uid,c_e_id) => {
  return request.post('/api/exam/make_exams', {
      "siteId":siteId,
      "token":uid,
    "examId":c_e_id
  })
}

// 做题记录
const makeExams = (siteId, uid, id) => {
    return request.post('/api/exam/make_exams_total', {
        "siteId": siteId,
        "token": uid,
        "cid": id
    })
}




// 试卷
const examination = (c_e_id) => {
  return request.post('/api/exam/examination', {

    "examId":c_e_id
  })
}
// 提交试卷
const handPapers = (siteId,uid,e_id, myanswer) => {
  return request.post('/api/exam/hand_papers', {
      "siteId":siteId,
    "token":uid,
    "examId":e_id,
     // "userTime":userTime,
    "answer":myanswer
  })
}
// 试题解析
const analysis = (examId,examDoId) => {
    console.log("examId1112="+examId)
    console.log("examDoId1112="+examDoId)
  return request.post('/api/exam/exam_analysis', {
      "examId": examId,
      "examDoId":examDoId
  })
}
// 用户信息
const getUserInfo = (siteId,token) => {
  return request.post('/api/site/user/getUserInfo',{"siteId":siteId,"token":token})
}


const getMyUserInfo = (siteId,token) => {
        return request.post('/api/site/user/getMyUserInfo',{"siteId":siteId,"token":token})
    }



// 修改信息
const goChangeInfo = (siteId,home_address, email, id) => {
  return request.post('/api/user/update_user', {
      "siteId":siteId,
    "home_address": home_address,
    "email": email,
    "id": id
  })
}

// 消息中心
const getMsgList = (siteId,token,type) => {
  return request.post('/api/bbs/notice', {
      "siteId":siteId,
    "token":token,
    "types": type
  })
}

// 消息详情
const getMsgDetail = (siteId,id) => {
  return request.post('/api/bbs/notice_info', {
      "siteId":siteId,
    "token": id
  })
}
// 我的笔记
const myNote = (siteId,token,page, limit) => {
  return request.post('/api/bbs/notice_info ', {
    "siteId":siteId,
    "token":token,
    "limit":limit,
    "page":page
  })
}
// 删除笔记
const delNote = (siteId,id) => {
  return request.post('/api/bbs/del_note', {
      "siteId":siteId,
    "token":id
  })
}
// 视频列表
const getVedioList = (siteId,id,cid) => {
  return request.post('/api/exam/course_study', {
      "siteId":siteId,
    "token": id,
      "clid": cid
  })
}

// 笔记列表
const getVedioBiji = (siteId,id, c_s_id) => {
  return request.post('/api/exam/notes', {
      "siteId":siteId,
    "token":id,
    "vid": c_s_id
  })
}

// 答疑列表
const getDayiList = (siteId,id,c_s_id) => {
  return request.post('/api/exam/answering', {
      "siteId":siteId,
    "token":id,
    "vid": c_s_id
  })
}

// 添加笔记
const addNote = (siteId,id,c_s_id,cid, content) => {
  return request.post('/api/exam/take_note', {
      "siteId":siteId,
    "token":id,
    "vid": c_s_id,
      "cid":cid,
    "content": content
  })
}
// 提交答疑  localStorage.getItem("info"),this.c_s_id, this.dayiContent, this.c_id, 5
const submitDayi = (siteId, uid, cid, content, vid, type) => {
  return request.post('/api/bbs/post_forum', {
      "siteId":siteId,
    "token":uid,
    "vid":vid,
      "content":content,
    "cid":cid,
    "types":type
  })
}

//提交答疑回复window.localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.c_s_id, contents, this.id,item.id,5

const submitAnswer = (siteId, uid, cid, content, vid, pid, type, answerTo) => {
    return request.post('/api/exam/save_answering', {
        "siteId": siteId,
        "token": uid,
        "vid": vid,
        "content": content,
        "cid": cid,
        "pid": pid,
        "types": type,
        "answerTo": answerTo
    })
}


// 视频播放结束
const vedioFinish = (siteId,id,c_s_id,now_time) => {
  return request.post('/api/exam/video_finish', {
      "siteId":siteId,
    "token":id,
    "vid": c_s_id,
    "nowTime": now_time
  })
}

// 视频播放进度
const videoWatch = (siteId,id,c_s_id,nowTime) => {
    return request.post('/api/exam/video_watch', {
        "siteId":siteId,
        "token":id,
        "vid": c_s_id,
        "nowTime":nowTime
    })
}

///api/exam/video_time

const videoTime = (siteId,id,c_s_id) => {
    return request.post('/api/exam/video_time', {
        "siteId":siteId,
        "token":id,
        "vid": c_s_id
    })
}


// 校园论坛
const forumIndex = (siteId,type, page, limit) => {
  return request.post('/api/bbs/index', {
      "siteId":siteId,
    "token":type,
    "page":page,
    "limit":limit
  })
}
// 发帖
const postForum = (siteId,title, content, atlas, type) => {
  return request.post('api/bbs/post_forum', {
      "siteId":siteId,
    "title":title,
    "content":content,
    "atlas":atlas,
    "types":type
  })
}
// 上传图片
const uploadImg = (siteId,file) => {
  return request.post('/api/upload/upload', {"siteId":siteId,"file":file })
}
// 我的帖子
const myForum = () => {
  return request.post('/api/bbs/my_forum', {
  })
}
// 我的回答
const myAnswer = () => {
  return request.post('/api/bbs/my_answer', {
  })
}
// 我的消息
const myMessage = () => {
  return request.post('/api/bbs/my_message', {
  })
}
// 删除我的回答和我的消息
const delMessage= (id) => {
  return request.post('/api/bbs/del_message', {
    id
  })
}
// 删除帖子
const delForum = (id) => {
  return request.post('/api/bbs/del_forum', {
    id
  })
}
// 论坛详情
const getTalkDetail = (f_id) => {
  return request.post('/api/bbs/info', {
    "token": f_id
  })
}
// 点赞
const takePraise=(siteId,f_id)=>{
  return request.post('/api/bbs/take_praise', {
      "siteId":siteId,
    "f_id": f_id
  })
}
// 取消点赞
const clearPraise=(siteId,f_id)=>{
  return request.post('/api/bbs/clear_praise', {
      "siteId":siteId,
    "f_id": f_id
  })
}

// 评论
const goPinuLun = (siteId,content, atlas, type, f_id, p_id, p_u_id) => {
  return request.post('/api/bbs/post_forum', {
      "siteId":siteId,
    "content":content,
    "atlas":atlas,
    "types":type,
    "f_id":f_id,
    "p_id":p_id,
    "p_u_id":p_u_id
  })
}
// 我的答疑
const myAnswering=(siteId,token,page,limit)=>{
  return request.post('/api/bbs/my_answering', {
      "siteId":siteId,
    "token":token,
    "page":page,
    "limit":limit
  })
}

// 成绩查询
const myScore=(siteId,uid)=>{
    return request.post('/api/exam/my_score', {
        "siteId":siteId,
        "token":uid
    })
}


const getSiteId = (domain) =>{
    return request({
        url: '/api/site/getSiteId',
        method: 'post',
        data: {'domain': domain}
    })
}

// 获取图片 token
const reqGet = (data) => {
    return request({
        url: '/login/get',
        method: 'post',
        data

    })
}
//滑动或者点选验证
const reqCheck = (data) => {
    return request({
        url: '/login/check',
        method: 'post',
        data

    })
}

//滑动或者点选验证
const reqVerify = (data) => {
    return request({
        url: '/login/verify',
        method: 'post',
        data

    })
}

export {
    makeExams,
    reqVerify,
    reqGet,
    reqCheck,
    submitAnswer,
    videoTime,
    videoWatch,
    logout,
    getUserMenu,
  getSiteId,
  myScore,
    getMyUserInfo,
  goLogin,
  getHome,
  getTerm,
  studyIndex,
  updatepass,
  courseExercises,
  makeNotes,
  examination,
    analysis,
  handPapers,
  getUserInfo,
  goChangeInfo,
  getMsgList,
  myNote,
  myAnswer,
  myMessage,
  delMessage,
  delNote,
  getMsgDetail,
  getVedioList,
  getVedioBiji,
  addNote,
  vedioFinish,
  forumIndex,
  postForum,
  goPinuLun,
  myForum,
  uploadImg,
  getTalkDetail,
  delForum,
  takePraise,
  clearPraise,
  myAnswering,
  getDayiList,
  submitDayi
}
